import React from 'react'; 
import PropTypes from 'prop-types';
import PhoneBox from '../Enhanced/PhoneBox';
import util from '../../lib/util';

export default class PhoneContact extends React.Component {
    render() {
        const name = this.props.name;
        const  colSpan = this.props.isWideCol ? "col-sm-12 col-md-6" : "col-sm-12 col-md-4";
        return (
            <div>
                <div className="row">
                    <div className={colSpan}>
                        <PhoneBox id={name + "_primaryPhone"} title="Primary phone number" name={name + "_primaryPhone"} ext="1" required />
                        <br />
                    </div>
                    <div className={colSpan}>
                        <PhoneBox id={name + "_secondaryPhone"} title="Secondary phone number" name={name + "_secondaryPhone"} ext="1" />
                    </div>
                </div>
                <div className="row">
                    <div className={colSpan}>
                        <PhoneBox id={name + "_primaryCellPhone"} title="Primary cell phone number" name={name + "_primaryCellPhone"} />
                        <br />
                    </div>
                    <div className={colSpan}>
                        <PhoneBox id={name + "_secondaryCellPhone"} title="Secondary cell phone number" name={name + "_secondaryCellPhone"} />
                    </div>
                </div>
            </div>
        );
    }
}

PhoneContact.propTypes = {
    name: PropTypes.string.isRequired,
};

export function PhoneContactValidator(name) {
    return [
        [name + "_primaryPhone", p => p[name + "_primaryPhone"], "Primary phone number"],
        [name + "_primaryPhone", p => !p[name + "_primaryPhone"] || util.isPhoneValid(p[name + "_primaryPhone"]), "Primary phone number"],
        [name + "_secondaryPhone", p => !p[name + "_secondaryPhone"] || util.isPhoneValid(p[name + "_secondaryPhone"]), "Secondary phone number"],
        [name + "_primaryCellPhone", p => !p[name + "_primaryCellPhone"] || util.isPhoneValid(p[name + "_primaryCellPhone"]), "Primary cell phone number"],
        [name + "_secondaryCellPhone", p => !p[name + "_secondaryCellPhone"] || util.isPhoneValid(p[name + "_secondaryCellPhone"]), "Secondary cell phone number"]
    ];
}